import React from "react";

// 12-point node-lattice (Tree-of-Life) mark, animated so nodes light up in sequence
// top -> bottom, echoing the Sovereign Signal logo.
const NODES = [
  { id: "A", x: 60, y: 12 },
  { id: "B", x: 28, y: 42 },
  { id: "C", x: 60, y: 40 },
  { id: "D", x: 92, y: 42 },
  { id: "E", x: 60, y: 66 },
  { id: "F", x: 28, y: 80 },
  { id: "G", x: 92, y: 80 },
  { id: "H", x: 60, y: 92 },
  { id: "I", x: 28, y: 108 },
  { id: "J", x: 92, y: 108 },
  { id: "K", x: 60, y: 134 },
  { id: "L", x: 60, y: 160 },
];

const N = Object.fromEntries(NODES.map((n) => [n.id, n]));

const EDGES = [
  ["A", "B"], ["A", "C"], ["A", "D"],
  ["B", "C"], ["C", "D"],
  ["B", "E"], ["C", "E"], ["D", "E"],
  ["B", "F"], ["D", "G"],
  ["F", "E"], ["G", "E"],
  ["F", "G"],
  ["F", "H"], ["G", "H"], ["E", "H"],
  ["F", "I"], ["G", "J"],
  ["I", "H"], ["J", "H"],
  ["I", "J"],
  ["I", "K"], ["J", "K"], ["H", "K"],
  ["K", "L"],
];

const CYCLE = 2.6; // seconds
const SPAN = 172; // viewBox height reference for delay mapping

export const SignalPulse = ({ size = 96, className = "", inline = false }) => {
  const h = size * (172 / 120);
  return (
    <div
      className={className}
      style={{
        width: size,
        height: h,
        display: inline ? "inline-block" : "block",
        verticalAlign: inline ? "middle" : undefined,
      }}
      data-testid="signal-pulse"
      role="status"
      aria-label="Loading"
    >
      <svg viewBox="0 0 120 172" width="100%" height="100%" aria-hidden="true">
        <defs>
          <filter id="sp-glow" x="-60%" y="-60%" width="220%" height="220%">
            <feGaussianBlur stdDeviation="2.2" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* connecting lattice lines */}
        <g stroke="#a855f7" strokeWidth="1" fill="none" filter="url(#sp-glow)">
          {EDGES.map(([a, b], i) => {
            const midY = (N[a].y + N[b].y) / 2;
            const delay = -(midY / SPAN) * CYCLE;
            return (
              <line
                key={i}
                x1={N[a].x}
                y1={N[a].y}
                x2={N[b].x}
                y2={N[b].y}
                className="sp-line"
                style={{ animationDelay: `${delay}s` }}
              />
            );
          })}
        </g>

        {/* nodes light up cascading top -> bottom */}
        <g filter="url(#sp-glow)">
          {NODES.map((n) => {
            const delay = -(n.y / SPAN) * CYCLE;
            return (
              <circle
                key={n.id}
                cx={n.x}
                cy={n.y}
                r="4.4"
                fill="#c084fc"
                className="sp-node"
                style={{ animationDelay: `${delay}s`, transformOrigin: `${n.x}px ${n.y}px` }}
              />
            );
          })}
        </g>
      </svg>
    </div>
  );
};

export default SignalPulse;
